module.exports = __webpack_public_path__ + "img/logo.9c8dda97.png";